/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import has from"../../core/has.js";const t=has("mac")?"Meta":"Control",o=new Set(["Alt","Control","Meta","Shift","Ctrl","Primary"]),r=t=>o.has(t);export{r as isSystemModifier,t as primaryKey};
